import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { isUniqueUser } from 'utils/booleanUtil'
import { responseUser } from 'utils/requestUtil'

type TableUserState = {
  selectList: responseUser[] // 選択ユーザー
}

const initialState: TableUserState = {
  selectList: [], // 選択ユーザー
}
export const TableUserSlice = createSlice({
  name: 'TableUser',
  initialState: initialState,
  reducers: {
    // 条件を全選択する処理 //===========================//
    checkUserAll: (state, action: PayloadAction<{ user: responseUser[]; isChecked: boolean }>) => {
      if (action.payload.isChecked) {
        // チェック解除処理
        state.selectList = []
      } else {
        // チェック処理
        state.selectList = action.payload.user
      }
    },
    // 条件を選択する処理 //===========================//
    checkUser: (state, action: PayloadAction<{ user: responseUser; isChecked: boolean }>) => {
      if (action.payload.isChecked) {
        // チェック除去
        state.selectList = state.selectList.filter((r) => !isUniqueUser(r, action.payload.user))
      } else {
        // チェック付与
        state.selectList.push(action.payload.user)
      }
    },
    // チェックリストを初期化する処理 //================================//
    formatCheck: (state) => {
      state.selectList = initialState.selectList
    },
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof TableUserState = key as keyof TableUserState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  checkUserAll, // 条件を全選択する処理
  checkUser, // 条件を選択する処理
  formatCheck, // チェックリストを初期化する処理
  format,
} = TableUserSlice.actions
export default TableUserSlice.reducer
